import styled from '@emotion/styled'
import { Flex, Radio, Tag, Text } from '@collable/ui'

interface ChannelVerifyMethodItemProps {
  title: string
  description: string
  isSelected: boolean
  tag?: string
  additionalInfo?: React.ReactNode
  onSelect: () => void
}

const ChannelVerifyMethodItem = ({
  title,
  description,
  isSelected,
  tag,
  additionalInfo,
  onSelect,
}: ChannelVerifyMethodItemProps) => {
  return (
    <Container direction="column" gap={20} as="label" isSelected={isSelected}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex direction="column" gap={6}>
          <Flex gap={8}>
            <Text size="body2" fontWeight="bold">
              {title}
            </Text>
            {tag && (
              <Tag size="small" type="soft" color="success">
                {tag}
              </Tag>
            )}
          </Flex>
          <Text size="body3" color="labelAlternative">
            {description}
          </Text>
        </Flex>
        <Radio size="large" checked={isSelected} onChange={onSelect} id={title} name={title} />
      </Flex>
      {isSelected && additionalInfo && <>{additionalInfo}</>}
    </Container>
  )
}

export default ChannelVerifyMethodItem

const Container = styled(Flex)<{ isSelected: boolean }>`
  width: 100%;
  padding: 24px;
  border-radius: 20px;
  border: 1px solid
    ${({ theme, isSelected }) =>
      isSelected ? theme.primary.primaryNormal : theme.line.lineNeutral};
`
